import React from 'react'
import {Text, Radio, RadioGroup} from 'react-form'
import {Grid, Row, Form, Col, FormGroup, Button} from 'react-bootstrap'
import moment from 'moment-jalaali'
import ProgressBar from '../../../Common/ProgressBar/ProgressBar'

import './ProfileEdit.css'

import {FaVenusMars, FaBirthdayCake, MdMailOutline, MdFace, MdPhoneIphone, MdPhone} from '../../../Common/ReactIcons/icons'

export default ({submitForm, setValue, getValue, getTouched, getError, isLoading}) => {
  if (window.__BROWSER_ENV__) {
    var { DatePicker } = require('react-persian-datepicker')
  }
  let tempDate = getValue('birthday') ? moment(getValue('birthday'), 'jYYYY/jMM/jDD') : ''
  return (
    <Grid fluid className="ProfileEdit">
      <Form horizontal onSubmit={submitForm}>
        <Row>
          <FormGroup>
            <Col sm={12} md={3} mdOffset={1}>
              <MdMailOutline />ایمیل
            </Col>
            <Col sm={12} md={7}>
              <Text
                field="email"
                className="form-control"
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col sm={12} md={3} mdOffset={1}>
              <MdFace /> نام
            </Col>
            <Col sm={12} md={7}>
              <Text
                field="full_name_fa"
                className="form-control"
                disabled={!getValue('canChangeName')}
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col sm={12} md={3} mdOffset={1}>
              <MdFace /> معادل
            </Col>
            <Col sm={12} md={7}>
              <Text
                field="full_name"
                className="form-control"
                disabled={!getValue('canChangeName')}
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col sm={12} md={3} mdOffset={1}>
              <FaVenusMars /> جنسیت
            </Col>
            <Col sm={12} md={7}>
              <RadioGroup field="gender">
                <label className="gender-male">
                  <Radio
                    value="male"
                  />
                  <span className="gender-male-label">آقا</span>
                </label>
                {' '}
                <label className="gender-female">
                  <Radio
                    value="female"
                  />
                  <span className="gender-female-label">بانو</span>
                </label>
              </RadioGroup>
            </Col>
          </FormGroup>

          <FormGroup>
            <Col sm={12} md={3} mdOffset={1}>
              <FaBirthdayCake /> تاریخ تولد
            </Col>
            <Col sm={12} md={7}>
              <div><DatePicker
                className="form-control"
                inputFormat="jYYYY/jMM/jDD"
                onChange={value => {
                  tempDate = value
                  setValue('birthday', value.format('jYYYY-jMM-jDD'))
                }}
                defaultValue={tempDate}
                /></div>
              <div className="FormError">{getError('birthday')}</div>
            </Col>
          </FormGroup>

          <FormGroup>
            <Col sm={12} md={3} mdOffset={1}>
              <MdPhoneIphone /> موبایل
            </Col>
            <Col sm={12} md={7}>
              <Text
                field="mobile"
                className="form-control"
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col sm={12} md={3} mdOffset={1}>
              <MdPhone /> تلفن
            </Col>
            <Col sm={12} md={7}>
              <Text
                field="phone"
                className="form-control"
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col sm={12} smOffset={0} mdOffset={4} md={7}>
              <Button type="submit" className={`btnBlock ${isLoading && 'disabled'}`} bsStyle="success">
                اعمال تغییرات
              </Button>
              <ProgressBar isLoading={isLoading} type="button" />
            </Col>
          </FormGroup>
        </Row>
      </Form>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/components/User/Profile/ProfileEdit/ProfileEditForm.js